var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInjuryArmRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 140,
    viewBox: "0 0 30 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.267 1c-1.453.749-2.736 1.36-3.869 1.923l-.512.257C7.776 6.77 6.948 8.807 6.948 33.5c0 29.05-3.01 42.646-4.664 54.2C1.18 95.405.789 112.5 1.107 138.985l10.619-.144v-14.697c6.538-17.728 9.746-29.876 9.626-36.442 0-18.155 2.4-31.831 7.2-41.028l-.109.21.11.275-.07-.348.07-.137z",
    fill: "#FC5A56",
    stroke: "#FC5A56",
    fillRule: "evenodd",
    opacity: 0.495
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryArmRight);
export default __webpack_public_path__ + "static/media/injury-arm-right.8d9f3fcb2628a43501e8807eeeda3ac1.svg";
export { ForwardRef as ReactComponent };